export default "__VITE_ASSET__90ed546b__"